import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref, watch, onMounted } from 'vue'
import type { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseForm2',
  props: {
  variable: { type: Array as PropType<{ [key: string]: any }[]>, required: true },
  formVal: { type: Object as PropType<{ [key: string]: any }>, required: false },
},
  setup(__props) {

const props = __props;



const formState = ref<any>({})
onMounted(() => {
  formState.value = props.formVal
})
watch(
  () => props.formVal,
  (value) => {
    if (value) {
      formState.value = value
    }
  },
  {
    deep: true
  }
)

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: formState.value,
    "label-width": "auto",
    class: "demo-dynamic"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.variable, (item) => {
        return (_openBlock(), _createBlock(_component_el_form_item, {
          label: item.name,
          key: item.key
        }, {
          default: _withCtx(() => [
            (item.type === 'input')
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  modelValue: formState.value[item.key],
                  "onUpdate:modelValue": ($event: any) => ((formState.value[item.key]) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            (item.type === 'select')
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 1,
                  size: "large",
                  modelValue: formState.value[item.key],
                  "onUpdate:modelValue": ($event: any) => ((formState.value[item.key]) = $event),
                  style: {"width":"100%"},
                  multiple: item.multiple
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (ele) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: ele.name,
                        value: ele.id,
                        key: ele.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "multiple"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["label"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})